// sagas.ts
import { call, put, takeLatest } from 'redux-saga/effects';
import {
    fetchTickersGroupSuccess,
    FetchTickersGroupRequestAction,
    fetchTickersSuccess,
} from './actions';
import { FETCH_GROUP_TICKERS_REQUEST, FETCH_TICKERS_REQUEST } from './constants';
import api from '../../../api-new/http';
import { appUrls } from '../../../api-new/urls';


export function* tickersGroupSaga(action: FetchTickersGroupRequestAction) {
    try {
        const data = yield call(() => api.get(`${appUrls.stockURL}/symbols/${action.payload}`));
        if (data) {
            yield put(fetchTickersGroupSuccess(data.data));
        }
    } catch (error) {
        // yield put(
        //     sendError({
        //         error,
        //         processingType: 'alert',
        //         extraOptions: {
        //             actionError: fetchTickersGroupFailure,
        //         },
        //     })
        // );
    }
}


export function* tickersAllSaga() {
    try {
        const data = yield call(() => api.get(`${appUrls.stockURL}/symbols`));
        if (data) {
            yield put(fetchTickersSuccess(data.data));
        }
    } catch (error) {
        // yield put(
        //     sendError({
        //         error,
        //         processingType: 'alert',
        //         extraOptions: {
        //             actionError: fetchTickersFailure,
        //         },
        //     })
        // );
    }
}
export function* rootTickerGroupSaga(): Generator {
    yield takeLatest(FETCH_GROUP_TICKERS_REQUEST, tickersGroupSaga);
    yield takeLatest(FETCH_TICKERS_REQUEST, tickersAllSaga);
}